export const CATEGORICAL_PALETTE: readonly string[] = [
  '#CE5555',
  '#B27034',
  '#A69330',
  '#869C2D',
  '#33A831',
  '#30A488',
  '#348CB2',
  '#5778CE',
  '#806BD4',
  '#A959CF',
  '#CA49A6',
  '#CD5176',
  '#B96E6E',
  '#B48B64',
  '#A2944E',
  '#89994A',
  '#51A550',
  '#4EA28E',
  '#629BB4',
  '#6E83B9',
  '#8072BB',
  '#A16EB9',
  '#B96EA4',
  '#B96E85',
  '#DE4545',
  '#B66820',
  '#A9931E',
  '#829C1C',
  '#21A91E',
  '#1DA584',
  '#1F84B0',
  '#4D76E0',
  '#8067E4',
  '#B14DE0',
  '#DA2FAA',
  '#DD3E6E',
] as const

const SPECIES_ORDER: readonly string[] = [
  'Mallard',
  'American Black Duck',
  'Northern Pintail',
  'Gadwall',
  'American Wigeon',
  'Blue-winged Teal',
  'Cinnamon Teal',
  'Green-winged Teal',
  'Northern Shoveler',
  'Wood Duck',
  'Mottled Duck',
  'Mexican Duck',
  'Redhead',
  'Canvasback',
  'Ring-necked Duck',
  'Greater Scaup',
  'Lesser Scaup',
  'Common Goldeneye',
  "Barrow's Goldeneye",
  'Bufflehead',
  'Ruddy Duck',
  'Long-tailed Duck',
  'Surf Scoter',
  'White-winged Scoter',
  'Black Scoter',
  'Common Eider',
  'King Eider',
  'Harlequin Duck',
  'Common Merganser',
  'Red-breasted Merganser',
  'Hooded Merganser',
  'Snow Goose (Lesser)',
  'Greater Snow Goose',
  "Ross's Goose",
  'Blue Goose',
  'Canada Goose',
  'Cackling Goose',
  'White-fronted Goose',
  'Greater White-fronted Goose',
  'Atlantic Brant',
  'Pacific Brant',
  'American Coot',
] as const

const DEFAULT_COLOR = '#8E877B'

function hashIndex(value: string, modulo: number): number {
  let h = 0
  for (let i = 0; i < value.length; i++) {
    h = (h * 31 + value.charCodeAt(i)) | 0
  }
  return ((h % modulo) + modulo) % modulo
}

export const SPECIES_COLORS: Record<string, string> = Object.fromEntries(
  SPECIES_ORDER.map((species, index) => [
    species,
    CATEGORICAL_PALETTE[index % CATEGORICAL_PALETTE.length],
  ]),
)

export function getSpeciesColor(species: string): string {
  const known = SPECIES_COLORS[species]
  if (known !== undefined) return known
  const index = hashIndex(species, CATEGORICAL_PALETTE.length)
  return CATEGORICAL_PALETTE[index] ?? DEFAULT_COLOR
}
